export const sadDinosAddress_rinkeby = "0x0c60408d6Bdb87dD65583660c66D0703Aa889665";
export const sadDinosAddress_mainnet = "0x9816eF551F838c95ddd56Fde7F080eCf424182d8";

const use_testnet = process.env.REACT_APP_CHAIN_ID === "4";

export const sadDinosAddress = use_testnet ? sadDinosAddress_rinkeby : sadDinosAddress_mainnet;